import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { createSelector } from 'reselect';
import PhoneWhite from '../assets/phone_white_96x96.png';
import PhoneBlue from '../assets/blue-phone-icon.png';

const getPhoneNumber = createSelector(
  state => state.core?.phoneNumber,
  phoneNumber => phoneNumber
);

const getMobileScreenSize = createSelector(
  state => state.ui?.screenSize?.isMobile,
  isMobile => isMobile
);

const Wrapper = styled.div`
  position: relative;
  height: 4rem;
  right: 2rem;
`;

const PhoneIcon = styled.img`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1;
  width: ${props => props.size || '2.5rem'};
  height: ${props => props.size || '2.5rem'};
`;

const Circle = styled.span`
  position: absolute;
  height: 4rem;
  width: 4rem;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  top: 0;
  left: 0;
`;

const TextWrapper = styled.div`
  font-size: 1.4rem;
  color: ${props => props.theme.carvana[props.textColor || 'blue']};
  font-weight: 700;
`;

const mapStateToProps = state => ({
  isMobile: getMobileScreenSize(state),
  number: getPhoneNumber(state)
});

const Phone = compose(connect(mapStateToProps))(
  ({ isMobile, number, replaceDashesWithDots, blueIcon, size, textColor }) => (
    <Fragment>
      {!isMobile && (
        <TextWrapper textColor={textColor}>
          {replaceDashesWithDots ? number?.replace(/-/g, '.') : number}
        </TextWrapper>
      )}

      {isMobile && (
        <Wrapper>
          <a href={`tel:${number}`}>
            <PhoneIcon
              size={size}
              src={blueIcon ? PhoneBlue : PhoneWhite}
              alt={number}
            />
            {!blueIcon && <Circle />}
          </a>
        </Wrapper>
      )}
    </Fragment>
  )
);

Phone.propTypes = {
  isMobile: PropTypes.bool,
  number: PropTypes.string,
  replaceDashesWithDots: PropTypes.bool,
  blueIcon: PropTypes.bool,
  size: PropTypes.string,
  textColor: PropTypes.string
};

Phone.defaultProps = {
  isMobile: false,
  number: null,
  replaceDashesWithDots: false,
  blueIcon: false,
  size: '2.5rem',
  textColor: 'blue'
};

export default Phone;
